import { render, staticRenderFns } from "./transaction-ref-no.vue?vue&type=template&id=038e2435&"
import script from "./transaction-ref-no.vue?vue&type=script&lang=js&"
export * from "./transaction-ref-no.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports